'use client';

import { create } from 'zustand';

interface SupportChatState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

/**
 * Drives the single app-level support chat panel (mounted via
 * `SupportWidget`). Opened from the floating launcher and from the
 * support screen.
 */
export const useSupportChatStore = create<SupportChatState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));

export const useOpenSupportChat = () => useSupportChatStore((s) => s.open);
